import { useTranslation } from "react-i18next";
import { isArray } from "lodash";
import { QuizAnsProps } from "../../../../../../types/scoring-course";
import EmptyComponent from "../../../../../../components/empty";

const VideoRecorder = ({ result }: QuizAnsProps) => {
  const { t } = useTranslation();
  const currentAnsOfUser = result?.results[0];

  return (
    <div className="center">
      {isArray(currentAnsOfUser) ? (
        <video className="quest-video" controls>
          <source
            src={currentAnsOfUser[0]?.contents[0] || ""}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      ) : <EmptyComponent description={t("Không có câu trả lời", "Không có câu trả lời")} />}
    </div>
  );
};

export default VideoRecorder;
